import { GridOptions } from 'ag-grid-community';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class GridDataService {
	groupiGridOptions: GridOptions;
	constructor() { }
	getGridOptions() {
		this.groupiGridOptions = {} as any;

		this.groupiGridOptions.headerHeight = 40;
		this.groupiGridOptions.rowHeight = 30;
		this.groupiGridOptions.floatingFiltersHeight = 30;

		this.groupiGridOptions.defaultColDef = {
			// make every column use 'text' filter by default
			filter: 'agTextColumnFilter',
			sortable: true,
			menuTabs :[],
			// suppressResize: true,
			suppressSizeToFit: true,
			// suppressColumnVirtualisation: true,
			headerClass: 'grid-header-class',
			cellStyle(_params) {
				return {
					'line-height': '27px'
				};
			},
			floatingFilterComponentParams: { suppressFilterButton: true },
			unSortIcon: true,
			icons: {
				sortUnSort: '<img src="assets/images/unsort.svg">',
			},

			filterParams: {
				textCustomComparator(_filter, value, filterText) {
					const filterTextLoweCase = filterText.toLowerCase();

					let valueLowerCase = '';
					if (value.params) {
						valueLowerCase = value.value.toString().toLowerCase();
					} else {
						valueLowerCase = value.toString().toLowerCase();
					}
					function contains(target, lookingFor) {
						if (target == null) {  // NOSONAR
							return false;
						}
						return target.indexOf(lookingFor) >= 0;
					}
					return contains(valueLowerCase, filterTextLoweCase);
				},
				// 		debounceMs: 2000,
				caseSensitive: true,
				suppressAndOrCondition: true
			}
		};

		this.groupiGridOptions.theme='legacy'
		
		return this.groupiGridOptions;
	}
	newGetGridOptions() {
		this.groupiGridOptions = {} as any;

		this.groupiGridOptions.headerHeight = 32;
		this.groupiGridOptions.rowHeight = 30;
		this.groupiGridOptions.floatingFiltersHeight = 30;
		// this.groupiGridOptions.rowBuffer = 500;
		// this.groupiGridOptions.suppressMovableColumns = true;
		// this.groupiGridOptions.editType = 'fullRow';
		// this.groupiGridOptions.getRowNodeId = d => {
		// 	return d.id; // return the property you want set as the id.
		// }
		// this.groupiGridOptions.paginationAutoPageSize=true;

		this.groupiGridOptions.defaultColDef = {
			// make every column use 'text' filter by default
			filter: 'agTextColumnFilter',
			sortable: true,
			menuTabs : [],
			// suppressResize: true,
			suppressSizeToFit: true,
			// suppressColumnVirtualisation: true,
			headerClass: 'grid-header-class',
			cellStyle(_params) {
				return {
					'line-height': '27px'
				};
			},
			floatingFilterComponentParams: { suppressFilterButton: true },
			unSortIcon: true,
			icons: {
				sortUnSort: '<img src="assets/images/unsort.svg">',
			},

			filterParams: {
				textCustomComparator(_filter, value, filterText) {
					const filterTextLoweCase = filterText.toLowerCase();

					let valueLowerCase = '';
					if (value.params) {
						valueLowerCase = value.value.toString().toLowerCase();
					} else {
						valueLowerCase = value.toString().toLowerCase();
					}
					function contains(target, lookingFor) {
						console.info(target)
						if (target == null) {  // NOSONAR
							return false;
						}
						return target.indexOf(lookingFor) >= 0;
					}
					return contains(valueLowerCase, filterTextLoweCase);
				},
				// 		debounceMs: 2000,
				caseSensitive: true,
				suppressAndOrCondition: true
			}
		};
		return this.groupiGridOptions;
	}
}
